import type { DueRitual } from '@/lib/workspace-rituals';
import { ritualTarget } from '@/components/rituals/ritual-targets';
import type { TodayEntry, TodayLaunch } from './today-launches';

/**
 * A ritual that opens an app (« Relire les comptes proposés… ») is the task of
 * handling that app's objects: while it is due and not done, the launches of
 * its app leave the list and the ritual carries their objects. Done or absent,
 * the launches stay rows of their own.
 */
export const placeRituals = (entries: TodayEntry[], rituals: DueRitual[]) => {
  const ritualOfApp = new Map<string, string>();
  rituals.forEach(({ ritual, occurrence }) => {
    const target = ritualTarget(ritual.route);
    if (target.kind === 'app' && !occurrence && !ritualOfApp.has(target.appKey)) ritualOfApp.set(target.appKey, ritual.id);
  });
  const carried = new Map<string, TodayLaunch>();
  const rest = entries.filter((entry) => {
    const ritualId = entry.kind === 'launch' && entry.launch.appKey ? ritualOfApp.get(entry.launch.appKey) : undefined;
    if (!ritualId || entry.kind !== 'launch') return true;
    const current = carried.get(ritualId);
    carried.set(ritualId, current
      ? {
          ...current,
          recordIds: [...new Set([...current.recordIds, ...entry.launch.recordIds])],
          planning: [...new Set([...current.planning, ...entry.launch.planning])],
          failed: [...current.failed, ...entry.launch.failed],
          items: [...current.items, ...entry.launch.items],
        }
      : { ...entry.launch, key: `ritual:${ritualId}`, runId: null, launchedAt: null });
    return false;
  });
  return { entries: rest, launchOf: (ritualId: string): TodayLaunch | null => carried.get(ritualId) ?? null };
};
